var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84585 18.686L10.1843 25.5526L18.2574 34.1784C18.6799 34.6297 19.3904 34.6468 19.8341 34.2163L34.1735 20.302C34.6244 19.8645 34.6204 19.1397 34.1648 18.7071L25.658 10.6316L19.3501 4.32372C19.1429 4.11645 18.8617 4 18.5686 4H4.658C4.04758 4 3.55273 4.49484 3.55273 5.10526V17.9363C3.55273 18.2141 3.65739 18.4818 3.84585 18.686Z",
    stroke: "#8A96A3",
    strokeWidth: 3.31579,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.2885,
    cy: 11.1841,
    r: 2.76316,
    fill: "#8A96A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1055 22.8492C15.1055 24.1599 16.168 25.2224 17.4787 25.2224H19.6825C21.0868 25.2224 22.2252 24.084 22.2252 22.6797C22.2252 21.2753 21.0868 20.1369 19.6825 20.1369H17.6482C16.2439 20.1369 15.1055 18.9985 15.1055 17.5941C15.1055 16.1898 16.2439 15.0514 17.6482 15.0514H19.852C21.1627 15.0514 22.2252 16.1139 22.2252 17.4246M18.6653 12V15.0514M18.6653 25.2224V27.9008",
    stroke: "#8A96A3",
    strokeWidth: 2.37325
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllList);
export default __webpack_public_path__ + "static/media/all_list.ddb9aecb1c799c4b20d97b6a1a1a1842.svg";
export { ForwardRef as ReactComponent };